import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ErrorCodeService {

    constructor() { }

    private _errorCode: number = 0;

    public get errorCode() {
        return this._errorCode;
    }

    public set showError(val) {
        this._errorCode = val;
    }
}
